<template>
  <div class="content">
    <div class="questionbox">
      <div v-if="exam.length !== 0" style="padding: 0 10px;">
        <div class="examtitle">
          <div class="an-title">
            <div class="num">{{ examindex + 1 }}.</div>
            <div class="ti">{{effect_datas[examindex].cp_classify_name}}</div>
          </div>
          <div class="conutd">
            {{h}}小时{{ m }}分钟 {{ s }}秒
          </div>
        </div>
        <div class="answer-list">
          <div class="tishi_ti">*目前组织在{{effect_datas[examindex].cp_classify_name}}的{{ effect_datas[examindex].cp_titles_name }}方面属于以下哪种情况</div>
          <el-radio-group
            class="form"
            v-model="choise[examindex]">
            <el-radio
              @change="e=>answerChange(e,item.select_score,item.id,effect_datas[examindex].cp_classify_id,effect_datas[examindex].cp_titles_id)"
              class="examradio"
              v-for="(item,index) in effect_datas[examindex].questions"
              :key="item.select_content"
              :label="index">
              {{ item.select_content }}
            </el-radio>
          </el-radio-group>

          <el-radio-group
            class="form othen"
            v-model="choises[effect_dataindex]"
            v-show="shows">
            <div class="tishi_ti">*企业项目维度目前在组织的产生效果</div>
            <div class="yangshi">
              <el-radio
                v-for="(list,key) in effect_datas[examindex].questions[effect_dataindex].effect_data"
                @change="es=>answerChanges(es,list.select_score,list.id)"
                class="examradio"
                :key="list.select_name"
                :label="list">
                {{ list.select_name }}
              </el-radio>
            </div>
          </el-radio-group>
        </div>
      </div>
      <div class="btngroup">
        <div>
          <el-button
            :type="examindex == 0 ? 'default':'success'"
            @click="preexam">上一题
          </el-button>
        </div>
        <div style="margin-left: 40px;" v-if="examindex != effect_datas.length-1">
          <el-button type="success" @click="nextexam">下一题</el-button>
        </div>
        <div style="margin-left: 40px;" v-else>
          <el-button type="success" @click="submit()">提交</el-button>
        </div>
      </div>
    </div>
  </div>

</template>

<script>
var indexurl = localStorage.getItem('url')
export default {
  data() {
    return {
      urlCode: '',
      examindex: 0,
      effect_dataindex: 0,
      exam: [],
      choise: {},
      choises: {},
      h:0,
      m: 0,
      s: 0,
      scores: [],
      effect_datas: [],
      shows: false,
      datas: [],
      cepingren: [],
      countdownTime: 4*60
    }
  },
  created() {
    this.getURL()
    this.getQuestion()
  },
  mounted() {
    this.pingxe()
    this.setTimer()
    this.setTimeData(this.countdownTime * 60 * 1000);
  },
  methods: {
    getURL() {
      let url = window.location.href
      this.urlCode = url.substring(url.indexOf("=") + 1)
    },
    pingxe() {
      let that = this
      this.$axios({
        method: "get",
        url: indexurl + "/index.php/api/index/getVisitorInfo?key=" + that.urlCode,
        data: {}
      }).then(res => {
        that.cepingren = res.data.data
      })
    },
    getQuestion() {
      let that = this
      this.$axios({
        method: "get",
        url: indexurl + "/index.php/api/index/questionsData?key=" + that.urlCode,
        data: {}
      }).then(res => {
        console.log(res.data.data,'anw')
        that.exam = res.data.data
        let arr = []
        res.data.data.map(item => {
          arr.push(item)
        })
        that.effect_datas = arr
      })

    },
    answerChange(e, s, id, cp_classify_id, cp_titles_id) {
      let idss = this.effect_datas[this.examindex].questions[e].effect_data[0].cp_questions_id
      if (id == idss) {
        this.shows = true
      } else {
        this.shows = false
      }
      this.effect_dataindex = e
      this.datas[this.examindex] = {
        cp_classify_id: cp_classify_id,
        cp_titles_id: cp_titles_id,
        questions_id: id,
        effect_data_id: ""
      }
    },
    answerChanges(es, ss, id) {
      this.scores[this.examindex] = ss
      this.datas[this.examindex].effect_data_id = id
    },
    nextexam() {
      this.shows = false
      if (this.scores[this.examindex]) {
        this.examindex = this.examindex + 1
      } else {
        this.$message({
          type: 'warning',
          message: '请选择答案'
        });
        return
      }
    },
    preexam() {
      if (this.examindex != 0) {
        this.examindex = this.examindex - 1
      }
    },
    submit() {
      let that = this
      let loading
      loading = this.$loading({
        lock: true,
        text: "上传中，请稍后",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      this.$axios({
        method: "POST",
        url: indexurl + "/index.php/api/index/postResult",
        data: {
          data: this.datas,
          key: this.urlCode,
          score: this.scores
        }
      }).then(res => {
        loading.close()
        this.to()
      })
    },
    setTimeData(cm) {
      this.h = Math.floor((cm / 1000 / 60 / 60) % 24);
      this.h =
        this.h.toString().length == 1 ? "0" + this.h : this.h;
      this.m = Math.floor((cm / 1000 / 60) % 60);
      this.m =
        this.m.toString().length == 1 ? "0" + this.m : this.m;
      this.s = Math.floor((cm / 1000) % 60);
      this.s =
        this.s.toString().length == 1
          ? "0" + this.s
          : this.s;
    },
    setTimer() {
      let _this = this;
      this.interval = setInterval(function () {
        _this.payCountdown(_this.countdownTime * 60 * 1000);
        clearInterval(_this.interval);
      }, 1000);
    },
    payCountdown(cm) {
      let _this = this;
      if (cm >= 0 ) {
        this.h = Math.floor((cm / 1000 / 60 / 60) % 24);
        this.h =
          this.h.toString().length == 1 ? "0" + this.h : this.h;
        this.m = Math.floor((cm / 1000 / 60) % 60);
        this.m =
          this.m.toString().length == 1
            ? "0" + this.m
            : this.m;
        this.s = Math.floor((cm / 1000) % 60);
        this.s =
          this.s.toString().length == 1
            ? "0" + this.s
            : this.s;
        let _msThis = this;
        setTimeout(function () {
          cm -= 1000;
          _msThis.payCountdown(cm);
        }, 1000);
      }
    },
    to(urlCode) {
      this.$router.push({
        path: '/components/cha',
        query: {
          urlCode: this.urlCode
        }
      })
    }
  }
}
</script>

<style scoped>
.content {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  padding-top:20px ;
  padding-bottom: 20px;
}

.examradio {
  /*width: 100%;*/
  line-height: 25px;
}

.form {
  display: flex;
  flex-direction: column;
  width: 100%;
}

.examtitle {
  display: flex;
  justify-content: space-between;
}

.an-title {
  display: flex;
}

.othen {
  flex-direction: column;
  justify-content: space-between;
  transition: all 0.5s ease-in-out;
}

.btngroup {
  display: flex;
  justify-content: space-around;
  align-content: center;
  margin-top: 25px;
}

.questionbox {
  width: 50%;
  padding: 20px;
  box-shadow: 0 0 10px 10px rgba(0, 0, 0, 0.3);
  border-radius: 10px;
  position: absolute;
  transform: translateY(-50%);
  top: 50%;
}

.num {
  font-size: 25px;
  font-weight: bold;
}

.ti {
  font-size: 22px;
}

.tishi_ti {
  color: red;
  font-size: 16px;
  margin-top: 15px;
}

.yangshi {
  display: flex;
  justify-content: space-between;
  align-items: center;
}


@media (max-width: 850px) {
  .questionbox {
    width: 70%;
    transition: all 0.5s ease-in-out;
  }
}

@media (max-width: 768px) {
  .examtitle{
    flex-direction: column;
  }
.conutd{
  text-align: end;
  padding: 10px 0;
}
  .questionbox {
    width: 80%;
    transition: all 0.5s ease-in-out;
    position: unset;
    transform: unset;
  }

  .el-radio {
    white-space: unset;
    margin-right: 0;
    margin-top: 10px;
  }

}
</style>



// WEBPACK FOOTER //
// src/components/answer/index.vue